<template>
  <div class="layout pad20" id="myComponentDiv">
    <div style="display: none">
      <input class="form-control" v-model="fecha" readonly disabled />
    </div>

    <div>
      <div class="label">Cliente</div>
      <div>
        <Select2 v-model="cliente" :options="lista_clientes" @select="selectCliente($event)" />
      </div>
    </div>

    <div class="row">
      <div class="col-lg-4">
        <div>Método de pago</div>
        <div>
          <select class="form-control" v-model="metodo_pago" :disabled="disabled_metodo_pago">
            <option :key="item._id" :value="item._id" v-for="item in lista_metodo_pago">
              {{ item.codigo }} - {{ item.descripcion }}
            </option>
          </select>
        </div>
      </div>

      <div class="col-lg-4">
        <div>Uso de CFDI</div>
        <div>
          <select class="form-control" v-model="uso_cfdi" :disabled="disabled_uso_cfdi">
            <option :key="item._id" :value="item._id" v-for="item in lista_uso_cfdi">
              {{ item.codigo }} - {{ item.descripcion }}
            </option>
          </select>
        </div>
      </div>

      <div class="col-lg-4">
        <div>Forma de pago</div>
        <div>
          <select class="form-control" v-model="forma_pago" :disabled="disabled_forma_pago">
            <option :key="item._id" :value="item._id" v-for="item in lista_forma_pago">
              {{ item.codigo }} - {{ item.descripcion }}
            </option>
          </select>
        </div>
      </div>
    </div>

    <div>
      <div>Observaciones</div>
      <div>
        <input class="form-control" v-model="observaciones" />
      </div>
    </div>

    <div class="facturador-titulo" v-on:click="abrirfiltros">
      FACTURAS ELECTRONICAS <i class="fa-solid fa-magnifying-glass"></i>
    </div>

    <div class="facturador-filtros" v-show="filtros_activos">
      <table width="100%">
        <tbody>
          <tr>
            <td width="50%">
              <div>Consecutivo</div>
              <input class="form-control" v-model="consecutivo" />
            </td>
            <td colspan="2">
              <div>CFDI</div>
              <input class="form-control" v-model="cdfi" />
            </td>
          </tr>
          <tr>
            <td>
              <div>Fecha inicio</div>
              <input id="fecha_inicio" placeholder="Fecha inicio" datatype="fecha" type="text" class="form-control"
                autocomplete="off" v-on:change="trigger()" v-model="fecha_inicio" />
            </td>
            <td>
              <div>Fecha final</div>
              <input id="fecha_final" placeholder="Fecha final" datatype="fecha" type="text" class="form-control"
                autocomplete="off" v-on:change="trigger()" v-model="fecha_final" />
            </td>
            <td>
              <div>.</div>
              <button class="btn btn-primary" @click="getReporteVentasPendiente">
                <i class="fa-solid fa-magnifying-glass"></i>
              </button>
            </td>
          </tr>
        </tbody>
      </table>
    </div>

    <br />
    <div class="tabla-scroll">
      <table>
        <thead>
          <tr>
            <th>FECHA</th>
            <th width="50px">SUBTOTAL</th>
            <th width="50px">IMP</th>
            <th width="50px">DTO</th>
            <th width="50px">TOTAL</th>
            <th width="50px"></th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="item in reporte" :key="item._id">
            <td style="padding-top: 10px !important">
              <table class="table-none" width="100%">
                <tbody>
                  <tr>
                    <td width="150px">
                      {{ item.fecha }}
                    </td>
                    <td class="table-none-factura">
                      {{ item.prefijo }}-{{ item.consecutivo }}
                    </td>
                  </tr>
                  <tr>
                    <td class="table-none-uuid" colspan="2">
                      {{ item.public_hasp }}
                    </td>
                  </tr>
                </tbody>
              </table>
            </td>
            <td width="100px">
              {{ GLOBAL.FORMATO_MONEY(item.venta_subtotal) }}
            </td>
            <td width="100px">
              {{ GLOBAL.FORMATO_MONEY(item.impuesto_total) }}
            </td>
            <td width="100px">
              {{ GLOBAL.FORMATO_MONEY(item.descuento_total) }}
            </td>
            <td width="100px">
              {{ GLOBAL.FORMATO_MONEY(item.venta_total) }}
            </td>
            <td width="50px">
              <div v-if="item.movimiento_id == null">
                <button v-if="!item.selected" @click="selectMe(item)" class="btn btn-primary btn-sm">
                  <i class="fa-solid fa-plus"></i>
                </button>
                <button v-if="item.selected" @click="deselectMe(item)" class="btn btn-danger btn-sm">
                  <i class="fa-solid fa-xmark"></i>
                </button>
              </div>
            </td>
          </tr>
        </tbody>
      </table>
    </div>

    <br />
    <hr />
    <br />

    <table class="center" width="400px">
      <tbody>
        <tr>
          <td colspan="2">
            <div>Nota Crédito</div>
            <div class="area-facturas-texto">
              <div v-if="factura_prefijo != null">
                <div>{{ factura_prefijo }}-{{ factura_consecutivo }}</div>
                <div style="font-size: 11px">
                  {{ factura_uniqueid }}
                </div>
              </div>
              <div v-else>[Borrador]</div>
            </div>
          </td>
        </tr>
        <tr>
          <td colspan="2" class="text-right">
            VALOR DE LA NOTA CRÉDITO:
          </td>
        </tr>
        <tr>
          <td width="60%" class="area-facturas-label"></td>
          <td>
            <input class="form-control text-right" :value="total_precio !== null ? total_precio : ''"
              @input="onInputTotalPrecio" style="padding-right: 8px; font-size: 30px" />
          </td>
        </tr>
        <tr>
          <td class="area-facturas-label"></td>
          <td class="text-right">
            {{ GLOBAL.FORMATO_MONEY(total_precio) }}
          </td>
        </tr>
        <tr>
          <td class="area-facturas-label">TOTAL MAX EN FACTURAS</td>
          <td class="text-right">
            {{ GLOBAL.FORMATO_MONEY(total_max_facturar) }}
          </td>
        </tr>
        <tr>
          <td class="area-facturas-label">CANTIDAD:</td>
          <td class="text-right">
            {{ GLOBAL.FORMATO_NUMBER(total_cantidad) }}
          </td>
        </tr>
        <tr>
          <td class="area-facturas-label">SUBTOTAL:</td>
          <td class="text-right">
            {{ GLOBAL.FORMATO_MONEY(total_subtotal) }}
          </td>
        </tr>
        <tr>
          <td class="area-facturas-label">IMPUESTO 16%:</td>
          <td class="text-right">
            {{ GLOBAL.FORMATO_MONEY(total_impuestos) }}
          </td>
        </tr>
        <tr style="border-top: 1px solid #777777">
          <td class="area-facturas-texto">TOTAL NOTA:</td>
          <td class="area-facturas-texto text-right">
            {{ GLOBAL.FORMATO_MONEY(total_facturar) }}
          </td>
        </tr>
      </tbody>
    </table>

    <br />
    <br />

    <table width="100%" class="table tabla-bordes" style="background-color: #fff">
      <tbody>
        <tr>
          <th>TICKET</th>
          <th width="80px" class="text-right">PRECIO CANT</th>
          <th width="80px" class="text-right">
            DESC<br />
            TOTAL
          </th>
          <th width="30px" class="text-right"></th>
        </tr>
        <tr :key="fact._id" :value="fact._id" v-for="fact in lista_facturar">
          <td>
            <div>
              {{ fact.fecha_formato }}
            </div>
            <div>{{ fact.prefijo }}-{{ fact.consecutivo }}</div>
            <div class="table-none-uuid">{{ fact.public_hasp }} &nbsp;</div>
          </td>
          <td class="text-right">
            <div>
              {{ GLOBAL.FORMATO_MONEY(fact.productos[0].precio) }}
            </div>
            <div>
              {{ GLOBAL.FORMATO_NUMBER(fact.productos[0].cantidad) }}
              <span class="area-facturas-unidad">
                {{ fact.unidad_codigo }}
              </span>
            </div>
          </td>
          <td class="text-right">
            <div class="text-red">
              -{{ GLOBAL.FORMATO_MONEY(fact.descuento_total) }}
            </div>
            <div>
              {{ GLOBAL.FORMATO_MONEY(fact.venta_total) }}
            </div>
          </td>
          <td class="pad10-r">
            <div v-if="factura_prefijo == null">
              <button @click="deselectMe(fact)" class="btn btn-danger btn-sm">
                <i class="fa-solid fa-xmark"></i>
              </button>
            </div>
          </td>
        </tr>
      </tbody>
    </table>

    <div class="text-center" v-if="mensaje">
      <img src="dist/img/guardando.gif" style="width: 30px" />
      <div>{{ mensaje }}</div>
    </div>

    <div class="text-center">
      {{ despacho_mensaje }}
    </div>

    <div class="text-center">
      <!-- Botón para enviar la nota de crédito -->
      <button class="btn btn-primary" @click="generaNotaCredito" v-if="!factura_consecutivo" :disabled="enviando_nota">
        <i class="fa-solid fa-envelope-circle-check"></i>
        <br />Enviar
      </button>

      <!-- Botón para consultar la nota ya generada -->
      <button class="btn btn-info" @click="consultaNotaCredito" :disabled="proceso_finalizado || consultando_nota"
        v-else>
        <i class="fa-solid fa-envelope-circle-check"></i>
        <br />Consulta
      </button>
    </div>

    <div v-if="!permiso_lista">
      {{ this.person.nombre }}, {{ this.GLOBAL.MENSAJE.SIN_AUTORIZACION }}
    </div>
  </div>
</template>

<script>
import GLOBAL from "../../Global.js";
import axios from "axios";
import FacturadorService from "../Facturador/FacturadorService";
import ClienteService from "../../service/ClienteService";
import Select2 from "vue3-select2-component";
import { useRoute } from "vue-router";

export default {
  data() {
    return {
      GLOBAL,
      fecha: null,
      fecha_inicio: null,
      fecha_final: null,

      facturadorService: null,
      clienteService: null,

      catalogo: null,

      lista_clientes: [],
      cliente: null,

      lista_tipo_venta: [],
      lista_perioricidad: [],

      lista_metodo_pago: [],
      metodo_pago: null,

      lista_forma_pago: [],
      forma_pago: null,

      lista_uso_cfdi: [],
      uso_cfdi: null,

      disabled_uso_cfdi: true,
      disabled_metodo_pago: true,
      disabled_forma_pago: true,

      observaciones: "",

      cdfi: "",
      consecutivo: "",
      reporte: [],
      lista_facturar: [],
      despacho_loading: false,
      despacho_mensaje: null,
      seleccionTodos: false,

      total_precio: null,
      total_facturar: 0,
      total_subtotal: 0,
      total_descuento: 0,
      total_cantidad: 1,
      total_impuestos: 0,
      total_max_facturar: 0,

      factura_prefijo: null,
      factura_consecutivo: null,
      factura_uniqueid: null,
      factura_enviada: false,
      factura_sello: null,
      mostrar_periodo: false,

      mensaje: null,
      zona_horaria: 0,

      enviando_nota: false,
      consultando_nota: false,
      proceso_finalizado: false,
      filtros_activos: false,
    };
  },
  components: { Select2 },
  created() {
    this.person = JSON.parse(sessionStorage.getItem(GLOBAL.SESSION_KEY));
    if (GLOBAL.COUNTRY == "MX") {
      this.FACTOR_CONVERSION = this.person.parametros.factor_m3;
    }
    this.empresa = this.person.empresas;
    this.permiso_lista = this.person.funciones.includes(
      GLOBAL.PERMISOS.REPORTE.HOROMETRO
    );

    this.facturadorService = new FacturadorService();
    this.clienteService = new ClienteService();

    this.fecha = GLOBAL.NOW_ISO();
    //this.fecha_inicio = GLOBAL.NOW().split(" ")[0] + " 03:45";
    //this.fecha_final = GLOBAL.NOW().split(" ")[0] + " 04:56";

    this.fecha_inicio = GLOBAL.NOW().split(" ")[0] + " 00:00";
    this.fecha_final = GLOBAL.NOW().split(" ")[0] + " 23:59";

    this.getCatalogos();
    this.getParametros();
    this.getListaClientes();
    this.facturar = [];

    this.metodo_pago = "48";
    this.forma_pago = "64";
    this.uso_cfdi = "2";
  },
  mounted() {
    this.loading = false;
    $("input[datatype='fecha']").datetimepicker();

    // Sincroniza -> Vue se entera cuando cambia el picker
    $("#fecha_inicio").on("change", () => {
      this.fecha_inicio = $("#fecha_inicio").val();
    });
    $("#fecha_final").on("change", () => {
      this.fecha_final = $("#fecha_final").val();
    });

    this.getReporteVentasPendiente();
  },
  methods: {
    abrirfiltros() {
      this.filtros_activos = !this.filtros_activos;
    },

    nuevaFactura() {
      this.resetDatos();
      this.cliente = null;
      this.despacho_mensaje = "";

      this.total_precio = 0;
      this.total_cantidad = 0;
      this.total_descuento = 0;
      this.total_subtotal = 0;
      this.total_facturar = 0;
    },

    selectCliente(client) {
      if (client.id == "0") {
      } else {
      }
    },

    onInputTotalPrecio(event) {
      const raw = event.target.value;
      const cleaned = raw.replace(/[^0-9.]/g, "").replace(/(\..*)\./g, "$1");
      event.target.value = cleaned;

      this.total_precio = cleaned === "" ? null : parseFloat(cleaned);
      this.recalculo();
    },

    getParametros() {
      this.loading = true;
      this.facturadorService
        .getParametros(this.person)
        .then((data) => {
          this.fecha = GLOBAL.NOW_WITH_TZ(data.parametros.zona_horaria);
        })
        .then(() => {
          this.loading = false;
        });
    },

    getListaClientes() {
      this.loading = true;
      this.clienteService
        .getReporteClientes(this.person)
        .then((data) => {
          console.log(data);

          this.lista_clientes.pop();
          this.lista_clientes.push({
            id: 0,
            text: "XAXX010101000 - PUBLICO GENERAL",
          });
          for (var i in data) {
            if (data[i].atributos == null) {
              data[i].atributos = [];
              data[i].atributos.fiscales = [];
              data[i].atributos.fiscales.metodo_pago = "";
              data[i].atributos.fiscales.uso_cfdi = "";
              data[i].atributos.fiscales.forma_pago = "";
            }

            if (typeof data[i].atributos.fiscales.metodo_pago == "undefined") {
              data[i].atributos.fiscales.metodo_pago = "";
            }

            if (typeof data[i].atributos.fiscales.uso_cfdi == "undefined") {
              data[i].atributos.fiscales.uso_cfdi = "";
            }

            if (typeof data[i].atributos.fiscales.forma_pago == "undefined") {
              data[i].atributos.fiscales.forma_pago = "";
            }

            this.lista_clientes.push({
              id: data[i]._id,
              text: data[i].identificacion + " - " + data[i].nombres,
              uso_cfdi: data[i].atributos.fiscales.uso_cfdi,
              metodo_pago: data[i].atributos.fiscales.metodo_pago,
              forma_pago: data[i].atributos.fiscales.forma_pago,
            });
          }
        })
        .then(() => {
          this.loading = false;
        });
    },

    getCatalogos() {
      if (this.catalogo == null) {
        this.facturadorService.getCatalogos(this.person).then((data) => {
          var json = data;
          for (const i in json) {
            switch (json[i].tipo) {
              case GLOBAL.CATALOGO_MEXICO.METODO_PAGO:
                this.lista_metodo_pago.push(json[i]);
                break;
              case GLOBAL.CATALOGO_MEXICO.FORMA_PAGO:
                this.lista_forma_pago.push(json[i]);
                break;
              case GLOBAL.CATALOGO_MEXICO.USO_CFDI:
                this.lista_uso_cfdi.push(json[i]);
                break;
              case GLOBAL.CATALOGO_MEXICO.TIPO_VENTA:
                this.lista_tipo_venta.push(json[i]);
                break;
              case GLOBAL.CATALOGO_MEXICO.PERIORICIDAD:
                this.lista_perioricidad.push(json[i]);
                break;
              default:
                break;
            }
          }
        });
      }
    },

    getReporteVentasPendiente() {
      this.reporte = [];
      this.loading = true;
 

      const url = GLOBAL.API_GET_REPORTE_FACTURA_ELECTRONICA_LIMITED;

      axios.get(url, {
        timeout: 10000,
        headers: {
          "Content-Type": "application/json;charset=UTF-8",
          Authorization: "Basic " + this.person.token,
          Environment: this.person.empresas,
        },
        params: {
          fechainicio: this.fecha_inicio,       // p.ej. "2025-10-03 00:00"
          fechafin: this.fecha_final,        // p.ej. "2025-10-03 23:59"
          estado: 1,
          cdfi: this.cdfi || undefined,        // solo se envía si tiene valor
          consecutivo: this.consecutivo || undefined,  // idem
        },
      })
        .then((response) => {
          this.reporte = response.data;
        })
        .catch((error) => {
          console.error("No se pudo cargar las facturas electrónicas", error);
          this.mensaje = "No se pudo cargar las facturas electrónicas";
        })
        .finally(() => {
          this.loading = false;
        });
    },


    generaNotaCredito() {
      this.despacho_mensaje = "";
      this.enviando_nota = true;
      let error = null;

      if (this.cliente == null) {
        error = "Seleccione un CLIENTE de la lista";
      }

      if (
        this.total_precio == 0 ||
        this.total_precio == null ||
        isNaN(this.total_precio)
      ) {
        error = "Digite un valor válido para la nota crédito";
      }

      if (this.total_precio > this.total_max_facturar) {
        error = "La nota crédito no debe superar el total de las facturas";
      }

      if (error == null) {
        this.mensaje = "";
        let items = [];

        for (const item of this.lista_facturar) {
          items.push({
            uniqueid: item.uniqueid,
            despacho_prefijo: item.prefijo,
            despacho_numero: item.consecutivo,
            public_hasp: item.public_hasp,
          });
        }

        let venta_total = this.total_precio;

        const impuesto_total = GLOBAL.CALCULAR_IVA(venta_total, 16);
        const venta_subtotal = venta_total - impuesto_total;
        const descuento_total = 0;

        const request = {
          fecha: this.fecha,
          empresa: this.person.empresas,
          persona_uniqueid: this.person.persona_id,
          tercero_uniqueid: this.cliente,
          fecha_creacion: this.fecha,
          costo_total: 0,
          venta_subtotal,
          impuesto_total,
          descuento_total,
          venta_total,
          estado: "P",
          atributos: {
            tipo_venta: this.tipo_venta,
            metodo_pago: this.metodo_pago,
            uso_cfdi: this.uso_cfdi,
            forma_pago: this.forma_pago,
            perioricidad: this.perioricidad,
            observaciones: this.observaciones,
          },
          items,
        };

        const url = GLOBAL.API_ENVIAR_NOTACREDITO_MEXICO_ELECTRONICA;

        axios
          .post(url.trim(), request, {
            timeout: 300000,
            headers: {
              "Content-Type": "application/json;charset=UTF-8",
              Authorization: "Basic " + this.person.token,
              Environment: this.person.empresas,
            },
          })
          .then((response) => {
            this.facturaId = response.data.facturaId;
            this.factura_uniqueid = response.data.uniqueId;
            this.factura_prefijo = response.data.prefijo;
            this.factura_consecutivo = response.data.consecutivo;

            this.mensaje =
              "Nota crédito creada con éxito, consulte para conocer el CDFI";
          })
          .catch((error) => {
            console.error("Error al enviar la nota crédito:", error);
            this.mensaje = "No se pudo realizar la nota crédito";
          })
          .finally(() => {
            this.enviando_nota = false;
          });
      } else {
        this.enviando_nota = false;
        this.mensaje = error;
      }
    },

    consultaNotaCredito() {
      this.despacho_mensaje = "";
      this.consultando_nota = true; // <- Bloquear el botón inmediatamente

      const request = {
        fecha: this.fecha,
        uniqueid: this.factura_uniqueid,
        factura_prefijo: this.factura_prefijo,
        factura_consecutivo: this.factura_consecutivo,
      };

      const url = GLOBAL.API_CONSULTA_NOTACREDITO_MEXICO_ELECTRONICA;

      axios
        .post(url.trim(), request, {
          timeout: 300000,
          headers: {
            "Content-Type": "application/json;charset=UTF-8",
            Authorization: "Basic " + this.person.token,
            Environment: this.person.empresas,
          },
        })
        .then((response) => {
          this.despacho_mensaje = response.data.cdfi;
          this.proceso_finalizado = true;
          this.mensaje = "Nota crédito emitida con éxito";
        })
        .catch((error) => {
          this.consultando_nota = false;
          console.error("Error al consultar la nota crédito:", error);
          this.mensaje = "No se pudo realizar la consulta";
        })
        .finally(() => {
          // El botón permanece deshabilitado después de la primera consulta
        });
    },

    selectAll() {
      this.seleccionTodos = !this.seleccionTodos;
      if (this.seleccionTodos) {
        for (const i in this.reporte) {
          this.selectMe(this.reporte[i]);
        }
      } else {
        for (const i in this.reporte) {
          this.deselectMe(this.reporte[i]);
        }
      }
      this.recalculo();
    },

    selectMe(ticket) {
      const index = this.lista_facturar.findIndex(
        (item) => item._id === ticket._id
      );

      var agregar = true;
      if (typeof this.lista_facturar[0] == "undefined") {
        agregar = true;
      } else {
        var item0 = this.lista_facturar[0];
        if (item0.precio == ticket.precio) {
          agregar = true;
        } else {
          agregar = false;
        }
      }

      if (index === -1 && agregar) {
        if (ticket.movimiento_id == null) {
          this.lista_facturar.push(ticket);
          ticket.selected = true;
        }
        this.recalculo();
      }
    },

    deselectMe(ticket) {
      const index = this.lista_facturar.indexOf(ticket);
      if (index > -1) {
        this.lista_facturar.splice(index, 1);
      }
      ticket.selected = false;
      this.recalculo();
    },

    recalculo() {
      this.total_max_facturar = 0;
      for (const i in this.lista_facturar) {
        this.total_max_facturar += this.lista_facturar[i].venta_total;
      }

      const valor = parseFloat(this.total_precio);

      if (isNaN(valor) || valor <= 0) {
        this.total_precio = null;
        this.total_cantidad = 0;
        this.total_subtotal = 0;
        this.total_impuestos = 0;
        this.total_facturar = 0;
        this.total_descuento = 0;
        return;
      }

      this.total_precio = valor;
      this.total_cantidad = 1;

      const iva = 16;
      const impuesto = GLOBAL.CALCULAR_IVA(valor, iva);
      const subtotal = valor - impuesto;

      this.total_subtotal = subtotal;
      this.total_impuestos = impuesto;
      this.total_facturar = valor;
      this.total_descuento = 0;
    },
    resetDatos() {
      this.factura_prefijo = null;
      this.factura_consecutivo = null;
      this.factura_enviada = true;
      this.cliente = "";
      this.tipo_venta = "";
      this.metodo_pago = "";
      this.uso_cfdi = "";
      this.forma_pago = "";
      this.observaciones = "";
      this.total_precio = 0;
      this.total_facturar = 0;
      this.reporte = [];
      this.lista_facturar = [];

      this.despacho_mensaje = "";

      this.mensaje_enviando = false;

      this.boton_guardar_desabilitado = true;
      this.boton_enviar_desabilitado = true;
      this.boton_consultar_desabilitado = true;
    },
  },
};
</script>

<style scoped>
.tabla-scroll {
  height: 300px;
  max-height: 300px;
  /* Altura visible del área con scroll */
  overflow-y: auto;
  /* Scroll vertical */
  border: 1px solid #ccc;
}

.tabla-scroll table {
  width: 100%;
  border-collapse: collapse;
}

.tabla-scroll thead th,
.tabla-scroll thead td {
  position: sticky;
  top: 0;
  background: #f9f9f9;
  /* o el color que necesites */
  border-bottom: 1px solid #ccc;
  padding: 8px;
}

.tabla-scroll tbody td {
  border-bottom: 1px solid #eee;
}

/*----------------------*/

.facturador-titulo {
  color: chocolate;
  font-weight: 700;
  font-size: 16px;
  border: 1px solid #ccc;
  margin-top: 30px;
  background-color: antiquewhite;
  text-align: center;
  padding: 5px 0px;

  -webkit-border-top-left-radius: 4px;
  -webkit-border-top-right-radius: 4px;
  -moz-border-radius-topleft: 4px;
  -moz-border-radius-topright: 4px;
  border-top-left-radius: 4px;
  border-top-right-radius: 4px;

  cursor: pointer;
}

.facturador-titulo:hover {
  background-color: rgb(255, 243, 15);
}

.facturador-filtros {
  padding: 10px;
  background-color: rgb(189, 189, 189);
}

.table-none,
.table-none td,
.table-none tr {
  padding: 0px !important;
  margin: 0px !important;
  border: 0px !important;
}

.table-none-factura {
  font-weight: bold !important;
}

.table-none-uuid {
  font-family: monospace;
  font-size: 12px;
}
</style>
